/*
 * @Author: yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-05-23 15:32:28
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-12-18 16:26:48
 * @FilePath: \MPC-monorepo\apps\mpc-inner\src\containers\ServiceConfig\DemoTest\ProTableForm\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, {
  useState,
  useRef,
  useCallback,
  useMemo,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from 'react';
import DemandConfigQuoteTable from '#features/MPCDemand/DemandConfigQuoteTable';
import {
  Button,
  Form,
  Input,
  Space,
  InputNumber,
  Spin,
} from '@bedrock/components';
import { SFormItem } from '#components/SForm';
import { apiService, defs } from '#services';
import ClosingReport from './ClosingReport';
import { $sType, localPx2rem } from '#utils';
import styles from './index.less';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

import { useMemoizedFn, useSize } from 'ahooks';
import AuditException from '#features/AuditException';
import {
  DemandAiReviewResultDto,
  DemandAiReviewResultItemDto,
} from '#services/api';
import { matchAiReviewResultItemKey } from '../bindAiReviewResultToFormItem';

export type ClosingReportProps = {
  detail: any;
  cooperateAccountId: number;
  reportList: any[];
  quoteData: any[];
  columns: any[];
  aiReviewResult?: DemandAiReviewResultDto;
  view?: boolean;
};

const ClosingReportTable = forwardRef(
  (
    {
      detail,
      reportList,
      view = true,
      cooperateAccountId,
      quoteData: propsQuoteData,
      columns: propsColumns,
      aiReviewResult: propsAiReviewResult,
    }: ClosingReportProps,
    ref
  ) => {
    const tableRef = useRef(null);
    const cooperateIdList = useMemo(() => {
      return detail?.demand_plan_info?.cooperate_accounts || [];
    }, [detail]);
    const [columns, setColumns] = useState(propsColumns);
    const [quoteData, setQuoteData] = useState(propsQuoteData);
    const [loading, setLoading] = useState(false);
    const [aiReviewResult, setAiReviewResult] =
      useState<DemandAiReviewResultDto>(propsAiReviewResult);
    const [form] = Form.useForm();

    const [closingReports, setClosingReports] = useState<any[]>(reportList);

    useImperativeHandle(ref, () => ({
      validateFields: () => {
        return form.validateFields();
      },
      getFieldsValue: () => {
        return form.getFieldsValue();
      },
    }));

    const [localView, setLocalView] = useState(view);

    const mergeColumns = useCallback(
      (tableColumns) => {
        const newColumns = tableColumns.map((column) => {
          if (column.addGroup) {
            column.children.push({
              dataIndex: 'closingReport',
              title: !localView ? (
                <span className={cx('required-text')}>结案报告</span>
              ) : (
                '结案报告'
              ),
              width: 440,
              editRender: null,
              fixed: 'right',
              mergeRowSpanKey: ['cooperateAccountId', 'quoteKey'],
              render: (value, row, index) => {
                const aiReviewResultItem = matchAiReviewResultItemKey(
                  `quoteSettleReport:${row?.quoteKey}:attachments`,
                  aiReviewResult?.items
                );
                return (
                  <SFormItem
                    showLabel={false}
                    formItemKey={['closingReportList', index]}
                    watchChildFormValidate={true}
                    validateTrigger={['change']}
                    render={(_, itemProps) => {
                      const matchRow = propsQuoteData?.find((item: any) => item?.quoteKey === row?.quoteKey && item?.cooperateAccountId === row?.cooperateAccountId);
                      return (
                        <ClosingReport
                          {...itemProps}
                          quote_key={row?.quoteKey}
                          view={localView}
                          muse={matchRow?.muse}
                          demandId={detail?.id}
                          indexId={detail?.demand_plan_info?.cooperate_accounts?.find((item: any) => item.id == row?.cooperateAccountId)?.index_id}
                          standardCode1={matchRow?.standardCode1}
                          standardCode2={matchRow?.standardCode2}
                          muse_url={matchRow?.museUrl}
                          muse_archive_status={detail?.muse_archive_status}
                          muse_file_stats={matchRow?.museFileStats}
                        />
                      );
                    }}
                    inputInlineExtra={
                      aiReviewResultItem ? (
                        <AuditException data={aiReviewResultItem} popover />
                      ) : null
                    }
                  />
                );
              },
            });
            return column;
          }
          return column;
        });
        if (cooperateAccountId) {
          // 如果有合作内容第一列不展示，只需要展示后续列
          return newColumns[1]?.children;
        }
        return newColumns;
      },
      [closingReports, localView, cooperateAccountId]
    );

    const parentRef = useRef(null);
    const parentSize = useSize(parentRef);

    return (
      <div ref={parentRef} className={cx('table-parent')}>
        {/* <Button onClick={
        () => {
          setLocalView(!localView);
        }
      }>
        切换编辑状态
      </Button> */}
        <Form
          form={form}
          initialValues={{
            closingReportList: reportList || [],
          }}
        >
          {loading && (
            <div className={cx('loading-container')}>
              <Spin tip={<span style={{ fontSize: 14 }}>加载中...</span>} />
            </div>
          )}
          {!!columns.length && !!quoteData.length && (
            <DemandConfigQuoteTable
              ref={tableRef}
              // scroll={{y: '100vh-' + localPx2rem(250), x: 'auto'}}
              scroll={{ y: parentSize?.height, x: 'auto' }}
              virtual={{ maxRows: 250, useAntd: true, itemHeight: 70 }}
              customScrollbarSize={6}
              value={quoteData}
              onChange={(changedValues) => {
                setQuoteData(changedValues);
              }}
              quoteTableColumns={columns}
              readOnly
              cooperateAccountList={cooperateIdList}
              mergeColumns={mergeColumns}
            />
          )}
        </Form>
      </div>
    );
  }
);

export default ClosingReportTable;
